import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f73e041"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "section-div",
  "data-aos": "fade-up"
}
const _hoisted_3 = { class: "cards-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  href: "mailto:{{ card.email }}",
  style: {"color":"#0072b1"}
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_ContractVehiclesBannerComponent = _resolveComponent("ContractVehiclesBannerComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderComponent, { screenName: "" }),
    _createVNode(_component_ContractVehiclesBannerComponent, {
      imageSrc: "contracts-banner.jpg",
      heading: "Contact Us"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "card"
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/contact/${card.imageSrc}`),
              alt: "Avatar",
              class: "avatar"
            }, null, 8, _hoisted_4),
            _createElementVNode("h2", null, _toDisplayString(card.name), 1),
            _createElementVNode("p", null, _toDisplayString(card.description), 1),
            _createElementVNode("p", null, [
              _createElementVNode("a", _hoisted_5, _toDisplayString(card.email), 1)
            ]),
            _createElementVNode("a", {
              href: card.linkedin,
              target: "_blank"
            }, [
              _createElementVNode("img", {
                src: require('@/assets/contact/linkedin.png'),
                alt: "LinkedIn",
                class: "linkedin-icon"
              }, null, 8, _hoisted_7)
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_FooterComponent)
  ]))
}